import ImageIcon from '@mui/icons-material/Image';
import ImageList from './ImageList';
import { ShowImage } from './ShowImage';

export default {
      list: ImageList,
      show: ShowImage,
      icon: ImageIcon,
}